import { useGetUserMe } from './useGetUserMe';

export const useGetUserCurrencyCode = () => {
  const { data: userMeData, ...restProps } = useGetUserMe();

  return {
    currencyCode: userMeData?.legalEntity?.currencyCode,
    ...restProps,
  };
};
